import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Host } from "../../../../model/host";
import { useHostOptions } from "./useHostOptions";

interface InstanceHostSelectionProps {
  value?: Host;
  /** Partner scope of the meeting: its staff are offered as hosts too. */
  partnerId?: string;
  onChange: (value: Host) => void;
}

export const InstanceHostSelection: React.FC<InstanceHostSelectionProps> = ({
  value,
  partnerId,
  onChange,
}) => {
  const { options, byId, partnerError } = useHostOptions(partnerId, [value]);

  return (
    <FormControl fullWidth margin="normal" error={!!partnerError}>
      <InputLabel id="host-select-label">Select a host:</InputLabel>
      <Select
        labelId="host-select-label"
        value={value?.id ?? ""}
        onChange={(e) => {
          const host = byId[e.target.value as string];
          onChange(host);
        }}
      >
        <MenuItem key="undef" value={undefined} selected={value === undefined}>
          Unset
        </MenuItem>
        {options.map(({ host, label }) => {
          return (
            <MenuItem
              key={host.id}
              value={host.id}
              selected={value?.id === host.id}
            >
              {label}
            </MenuItem>
          );
        })}
      </Select>
      {partnerError && <FormHelperText>{partnerError}</FormHelperText>}
    </FormControl>
  );
};
